import React from 'react';
import styles from './SizePills.module.css';
import {
  getSizeArray,
  isSizeAvailable,
  parseAvailableSizes,
} from './SizePills.utils';

export interface SizePillsProps {
  availableSizes?: string | null;
  onClick?: (e: React.MouseEvent) => Promise<void> | void;
  className?: string;
  selectedSize?: string | null;
  onSizeSelect?: (size: string) => void;
}

const SizePills: React.FC<SizePillsProps> = ({
  availableSizes,
  onClick,
  className = '',
  selectedSize = null,
  onSizeSelect,
}) => {
  const parsedSizes = parseAvailableSizes(availableSizes);

  const allSizes = getSizeArray(parsedSizes);

  const handleSizeClick = (size: string, e: React.MouseEvent): void => {
    if (isSizeAvailable(size, parsedSizes)) {
      if (onSizeSelect) {
        onSizeSelect(size);
      }
      if (onClick) {
        onClick(e);
      }
    }
  };

  return (
    <div className={`${styles.sizeContainer} ${className}`}>
      <div className={styles.sizePills}>
        {allSizes.map((size) => {
          const isAvailable = isSizeAvailable(size, parsedSizes);
          const isSelected = selectedSize === size;

          return (
            <button
              key={size}
              className={`${styles.sizePill} ${
                isSelected
                  ? styles.selected
                  : isAvailable
                    ? styles.available
                    : styles.unavailable
              }`}
              disabled={!isAvailable}
              aria-label={`Size ${size}${isSelected ? ' selected' : isAvailable ? ' available' : ' unavailable'}`}
              onClick={(e) => handleSizeClick(size, e)}
            >
              <span className={styles.sizeText}>{size}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SizePills;
